import { render } from "./Inventory_Product_Dialog.vue?vue&type=template&id=0e93f1af&scoped=true"
import script from "./Inventory_Product_Dialog.vue?vue&type=script&lang=js"
export * from "./Inventory_Product_Dialog.vue?vue&type=script&lang=js"

import "./Inventory_Product_Dialog.vue?vue&type=style&index=0&id=0e93f1af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e93f1af"]])

export default __exports__